@if (loadingWrapper && loadingWrapper.errorLoading$ | async; as error) {
  <div>
    @if (error.valueOf()) {
      <div class="error-loading-container">
        <h2 class="error-message">{{message}}</h2>
        <button class="error-loading-reload-btn" mat-stroked-button (click)="reload()">
          <mat-icon color="primary">refresh</mat-icon>
          Erneut Laden
        </button>
      </div>
    }
  </div>
} @else {
  <app-loading-spinner></app-loading-spinner>
}
